<template>
  <div>
    <a
      class="flex p-2 my-1 text-left text-black transition-all duration-300 rounded cursor-pointer hover:bg-gray-100"
      :class="{ 'items-center': isOneLine, 'bg-gray-100': isSelected }"
      @click="viewProfile()"
      data-qa="search_results"
      data-test-id="search-results"
    >
      <div class="mr-2" data-qa="athlete_info">
        <avatar data-qa="athlete_basic_info"
          :firstName="firstName"
          :lastName="lastName"
          :imageUrl="imageUrl"
          :size="24"
        />
      </div>

      <div class="flex flex-col flex-1">
        <!-- Name, Grad Year, Verification -->
        <div class="font-semibold text-gray-900 ds-text-sm flex justify-start">
          <div class="w-full">
            <MatchText :query="query" :parts="[firstName, lastName]" />
            <span v-if="showAditionalInfo" class="mr-1" data-test-id="coma">,</span>
            <span v-if="hasClassYear" class="mr-1" data-test-id="class-year">{{ year }}</span>
            <span v-if="isTransfer" data-test-id="transfer">Transfer</span>

            <VerifiedBadge v-if="isVerified" size="sm" class="ml-1" data-qa="verified_badge" />
          </div>
            <div class="flex flex-row items-center ds-text-2xs text-white">
              <div v-if="isFavorited" class="flex flex-row items-center bg-pink-300 rounded-full h-4 w-4 " data-qa="favorite_icon">
                <i  class=" m-auto sr-2 sr-v2-heart-filled"></i>
              </div>
              <div v-if="isInterested" class="flex flex-row items-center  bg-green-300 rounded-full h-4 w-4 -ml-1" data-qa="interested_icon">
                <i class=" m-auto sr-2 sr-v2-mortar-board"> </i>
              </div>
            </div>



          <div><!--Fav/Interested --></div>
        </div>

        <!-- Position -->
        <DetailLine v-if="hasPositions">
          Position: {{ positions.join(", ") }}
        </DetailLine>
        <div class="text-gray-500 ds-text-xs font-normal">
          <!-- Club, HS  -->
          <span v-if="clubName">Club: {{ clubName }}</span>
          <span v-if="clubName && highSchoolName" class="mx-1">&bull;</span>
          <span v-if="highSchoolName">HS: {{ highSchoolName }}</span>
        </div>
      </div>
    </a>
    <!-- divider -->
    <div class="h-1px bg-gray-300 w-full" v-if="!isLast"></div>
  </div>
</template>

<script>
import Avatar from "@/components/UserAvatar";
import MatchText from "./MatchText";
import DetailLine from "./ResultItemDetailLine";
import VerifiedBadge from "@/components/Verification/VerifiedBadge";

export default {
  components: {
    Avatar,
    MatchText,
    DetailLine,
    VerifiedBadge,
  },

  props: {
    data: { type: Object, required: true },
    query: { type: String, required: true },
    isSelected: { type: Boolean, default: false },
    isLast: { type: Boolean, default: false },
  },

  computed: {
    firstName() {
      return this.data.firstName;
    },

    lastName() {
      return this.data.lastName;
    },

    name() {
      return `${this.firstName} ${this.lastName}`;
    },

    isInterested() {
      return this.data.isInterested
    },

    isFavorited() {
      return !!(this.data.player.playerFavorites && this.data.player.playerFavorites.length)
    },

    image() {
      return this.data.player.images[0] || '';
    },

    imageUrl() {
      return this.image ? this.image.url : null;
    },

    initials() {
      return this.data.firstName.charAt(0) + this.data.lastName.charAt(0);
    },

    year() {
      return this.data.userPlayerInfo.classYear;
    },

    hasClassYear() {
      return !!this.year;
    },

    isTransfer() {
      return this.data.userPlayerInfo.isTransfer;
    },

    showAditionalInfo() {
      return this.hasClassYear || this.isTransfer;
    },

    positions() {
      const sportValue = this.data.player.sportValues
        .filter((sportValue) => sportValue && sportValue.value)
        .find((sportValue) => sportValue.sportField.field_name === "position");

      return sportValue ? sportValue.value.split("|").filter((pos) => pos) : [];
    },

    hasPositions() {
      return this.positions && this.positions.length > 0;
    },

    clubName() {
      const club = this.data.player.clubs.filter(
        (c) => c.organization_type === "club"
      )[0];
      return (club && club.name) || this.data.player.clubString || null;
    },

    highSchoolName() {
      const club = this.data.player.clubs.filter(
        (c) => c.organization_type === "high school"
      )[0];
      if (this.data.userPlayerInfo.highschool === "null") return null;
      return (club && club.name) || this.data.userPlayerInfo.highschool || null;
    },

    isVerified() {
      return !!this.data.verified_at;
    },

    isOneLine() {
      return !this.hasPositions && !this.clubName && !this.highSchoolName;
    },
  },

  methods: {
    viewProfile() {
      this.$emit("clicked", this.data);
    },
  },

  watch: {
    isSelected(is) {
      if (is) {
        const scrollContainer = $(this.$el)
          .closest("[data-scroll-container]")
          .get(0);

        if (
          this.$el.offsetTop + $(this.$el).outerHeight() >
          scrollContainer.scrollTop + $(scrollContainer).innerHeight()
        ) {
          scrollContainer.scrollTo(
            0,
            Math.max(
              0,
              this.$el.offsetTop -
                $(scrollContainer).innerHeight() +
                $(this.$el).outerHeight()
            )
          );
        } else if (this.$el.offsetTop < scrollContainer.scrollTop) {
          scrollContainer.scrollTo(0, this.$el.offsetTop);
        }
      }
    },
  },
};
</script>
